import * as React from 'react';

interface ResourcesLoaderProps {
	css: string;
	themesCss?: string;
	scripts?: string;
}

enum ResourceType {
	STYLE = 'style',
	SCRIPT = 'script',
}

const STYLE_ID = 'editor-styles';
const THEMES_STYLE_ID = 'editor-themes-styles';
const SCRIPTS_ID = 'editor-scripts';

const addResource = (type: ResourceType, id: string, resource: string): void => {
	const element = document.createElement(type);
	element.id = id;
	element.innerHTML = resource;
	document.head.appendChild(element);
};

const removeResource = (id: string): void => {
	const element = document.querySelector(`#${id}`);
	if (element) {
		element.parentNode!.removeChild(element);
	}
};

const addStyles = (css: string): void => addResource(ResourceType.STYLE, STYLE_ID, css);
const removeStyles = (): void => removeResource(STYLE_ID);

const addThemesStyles = (themesCss: string): void => addResource(ResourceType.STYLE, THEMES_STYLE_ID, themesCss);
const removeThemesStyles = (): void => removeResource(THEMES_STYLE_ID);

const addScripts = (scripts: string): void => addResource(ResourceType.SCRIPT, SCRIPTS_ID, scripts);
const removeScripts = (): void => removeResource(SCRIPTS_ID);

const ResourcesLoader = ({ css, themesCss, scripts }: ResourcesLoaderProps) => {
	React.useEffect(() => {
		addStyles(css);

		if (scripts) {
			addScripts(scripts);
		}

		return () => {
			removeStyles();
			removeScripts();
		};
	}, [css, scripts]);

	React.useEffect(() => {
		if (themesCss) {
			addThemesStyles(themesCss);
		}

		return () => {
			removeThemesStyles();
		};
	}, [themesCss]);

	return null;
};

export default ResourcesLoader;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ResourcesLoader/index.tsx